<template>
  <div>
    <iModal
      title="Associate old phone"
      :closable="false"
      :mask-closable="false"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="700px"
      @on-cancel="cancel"
      @on-visible-change="changeValidType"
    >
      <div class="account-add" style="padding-right: 20px;">
        <!-- <p v-if="validType === 0">绑定新手机</p>
        <p v-if="validType === 1">验证旧手机</p>
        <p v-if="validType === 2">用新手机绑定旧手机</p> -->
        <div class="account-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="160"
            @submit.native.prevent
          >
            <FormItem label="Old phones number：" prop="mobile">
              <Input type="text" v-model="formInline.mobile" placeholder="Old phones number" />
            </FormItem>
            <FormItem label="captcha：" class="form-code-item" prop="captcha">
              <Row>
                <Col span="10">
                  <Input type="text" v-model="formInline.captcha" placeholder="captcha" />
                </Col>
                <Col span="12" push="2">
                  <Button
                    v-if="showCode"
                    @click="getCaptcha('formInline')"
                    style="width: 100%;"
                  >Get Captcha</Button>
                  <Button v-else disabled style="width: 100%;">{{count}}s Retrieve again later</Button>
                </Col>
              </Row>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="next('formInline')">Next</Button>
        <Button @click="cancel">Cancel</Button>
      </div>
    </iModal>
    <iModal
      title="Associate new phone"
      :closable="false"
      :mask-closable="false"
      v-model="showModal2"
      width="700px"
      @on-visible-change="changeValidType2"
    >
      <div class="account-add">
        <!-- <p v-if="validType === 0">绑定新手机</p>
        <p v-if="validType === 1">验证旧手机</p>
        <p v-if="validType === 2">用新手机绑定旧手机</p> -->
        <div class="account-add-content">
          <Form
            ref="formInline2"
            :model="formInline2"
            :rules="ruleInline"
            label-position="right"
            :label-width="160"
            @submit.native.prevent
          >
            <FormItem label="New phones number：" prop="mobile">
              <Input type="text" v-model="formInline2.mobile" placeholder="New phones number" />
            </FormItem>
            <FormItem label="Captcha：" class="form-code-item" prop="captcha">
              <Row>
                <Col span="10">
                  <Input type="text" v-model="formInline2.captcha" placeholder="Captcha" />
                </Col>
                <Col span="12" push="2">
                  <Button
                    v-if="showCode"
                    @click="getCaptcha('formInline2')"
                    style="width: 100%;"
                  >Get Captcha</Button>
                  <Button v-else disabled style="width: 100%;">{{count}}s Retrieve again later</Button>
                </Col>
              </Row>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading2" @click="bind('formInline2')">Associate</Button>
        <Button @click="cancel">Cancel</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { validator } from "@/other/validatorEn";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "changePhone",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      loading2: false,
      showModal: false,
      showModal2: false,
      phone: "", // 原手机号
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      oldTel: "",
      adminInfo: null, // 管理员信息
      formInline: {
        // form双向绑定
        mobile: "",
        captcha: ""
      },
      formInline2: {
        // form双向绑定
        mobile: "",
        captcha: ""
      },
      ruleInline: {
        // 效验规则
        mobile: validator.phone,
        captcha: [
          {
            required: true,
            message: "Captcha is required",
            trigger: "blur"
          }
        ]
      },
      validType: 0, // 三种状态 0：绑定新手机  1：验证原手机 2：绑定新手机
      firstToken: '', // 验证新手机之前的旧手机
    };
  },
  watch: {
    show(val, oldVal) {
      if (!this.phone) {
        this.showModal2 = val;
      } else {
        this.showModal = val;
      }
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany"
    })
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getStaffByCompId: "companyModule/getStaffByCompId", 

      changePhoneToken: "companyModule/changePhoneToken", // （原手机不为空） 新手机发送验证码
      changePhoneOldToken: "companyModule/changePhoneOldToken", // （原手机不为空） 发送验证码
      changePhoneApply: "companyModule/changePhoneApply", // （原手机不为空） 验证并更改手机
      changePhoneOldCheck: "companyModule/changePhoneOldCheck", // （原手机不为空） 验证手机验证码（省略）

      bindPhoneToken: "companyModule/bindPhoneToken", // （原手机为空） 发送验证码
      bindPhoneApply: "companyModule/bindPhoneApply" // 验证并更改手机 绑定手机（原手机为空）
    }),
    async init() {
      let arr = []; 
      let staffArr = await this.getStaffByCompId(this.company.id);
      staffArr.forEach(c => {
        // if (c.roleId === 1) {
          this.adminInfo = c;
          this.phone = c.phoneNumber;
          if (!this.phone) {
            this.validType = 0;
          }
        // }
      });
    },
    async bind() {
      // 绑定手机
      if (this.validType === 0) {
        this.bindNewPhone();
      }
      if (this.validType === 2) {
        this.bindNewPhoneByOldPhone();
      }
    },
    async bindNewPhone() {
      // 绑定新手机
      let valid = await this.bindPhoneApply({
        UserId: this.adminInfo.userId,
        NewPhoneNumber: this.formInline2.mobile,
        token: this.formInline2.captcha
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        this.$Message.error('验证码错误！');
        // this.$Message.error(valid.errors[0].description);
        return;
      }
      this.$Message.success("绑定成功!");
      this.cancel();
    },
    async bindNewPhoneByOldPhone() {
      // 通过旧手机绑定新手机
      let valid = await this.changePhoneApply({
        UserId: this.adminInfo.userId,
        OldPhoneNumber: this.phone,
        NewPhoneNumber: this.formInline2.mobile,
        token: this.formInline2.captcha
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        this.$Message.error('验证码错误！');
        // this.$Message.error(valid.errors[0].description);
        return;
      }
      this.$Message.success("绑定成功!");
      this.cancel();
    },
    async next() {
      let form = this.formInline;
      let valid = await this.validForm('formInline');
      if (!valid) return; 
      let bool = await this.changePhoneOldCheck({
        UserId: this.adminInfo.userId,
        OldPhoneNumber: this.formInline.mobile,
        token: this.formInline.captcha
      }); 
      if (!bool) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (!bool.successed) {
        
        this.$Message.error('验证码错误！');
        // this.$Message.error(valid.errors[0].description);
        this.formInline.captcha = "";
        return;
      }
      this.firstToken = this.formInline.captcha;
      this.$Message.success("验证成功!");
      // 验证原手机通过 跳到下一步
      this.showModal = false;
      this.showCode = true;
      clearInterval(this.timer);
      this.timer = null;
      this.formInline.captcha = "";
      this.formInline.captcha2 = "";
      this.showModal2 = true;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    getCaptcha(name) {
      this.$refs[name].validateField("mobile", val => {
        if (val !== "") return;
        this.downTime(name);
      });
    },
    async downTime(name) {
      let valid = null;
      if (this.validType === 0) {
        // 绑定新手机
        valid = await this.bindPhoneToken({
          UserId: this.adminInfo.userId,
          NewPhoneNumber: this.formInline2.mobile
        });
      }
      if (this.validType === 1) {
        // 验证原手机
        valid = await this.changePhoneOldToken({
          UserId: this.adminInfo.userId,
          OldPhoneNumber: this.formInline.mobile 
        });
      }
      if (this.validType === 2) {
        // 绑定新手机
        valid = await this.changePhoneToken({
          UserId: this.adminInfo.userId,
          OldPhoneNumber: this.phone,
          NewPhoneNumber: this.formInline2.mobile,
          token: this.firstToken
        });
      }
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    }, 
    cancel() {
      this.showModal = false;
      this.showModal2 = false;
      if (this.$refs["formInline"]) {
        this.$refs["formInline"].resetFields();
      }
      if (this.$refs["formInline2"]) {
        this.$refs["formInline2"].resetFields();
      }
      this.firstToken = '';
      this.$emit("finish");
      this.$emit("close");
    },
    changeValidType2(bool) {
      if (bool) {
        if (!this.phone) {
          this.validType = 0; // 绑定新手机
        } else {
          this.validType = 2; // 用新手机绑定旧手机
        }
      }
    },
    changeValidType(bool) {
      if (bool) {
        this.validType = 1; // 验证旧手机
      }
    }
  }
};
</script>

<style scoped lang="scss">
.account-add {
  padding-right: 20px;
  padding-top: 20px;
}
</style>

